/* eslint-disable @typescript-eslint/naming-convention */
export interface ITOEventColumnDefinition {
  columnOrderNo: number;
  outcomeOrderNo: number;
  columnType: TOCompetitionEventsColumnType;
  dateTime: string;
  title: string;
  betTypeId: number;
  betTypeOutcomeId: number;
  betTypeName: string;
  field: string;
  betTypeOrderNo: number;
  outcomesNo: number;
}

export enum TOCompetitionEventsColumnType {
  Odd = 1,
  Sbv = 2
}
